import type { Locale } from "@llmgateway/i18n";

export const heroSuggestionGroups = {
	Create: [
		"Write a Python script to analyze CSV data and create visualizations",
		"Create a compelling elevator pitch for a sustainable fashion startup",
		"Explain quantum computing like I'm 12 years old",
		"Design a 7-day workout plan for busy professionals",
		"Write a short mystery story in exactly 100 words",
		"Draft a launch announcement for a new productivity app",
		"Create a weekly meal plan for a vegetarian family",
		"Write a persuasive email asking for a project extension",
		"Design a morning routine for better focus and energy",
		"Create a checklist for moving into a new apartment",
		"Write a heartfelt birthday message for a close friend",
		"Draft a social media calendar for a local bakery",
		"Create a budget plan for saving for a vacation",
		"Write a product description for noise-canceling headphones",
		"Design a 30-day habit-building challenge",
		"Create a study schedule for final exams",
		"Write a professional bio for a conference speaker",
		"Draft a customer feedback survey for a SaaS product",
		"Create a packing list for a two-week Europe trip",
		"Write a bedtime story about a curious astronaut",
		"Design a beginner-friendly home workout routine",
		"Create interview questions for a product manager role",
		"Write a fundraising pitch for an animal shelter",
		"Draft a newsletter intro for a design studio",
		"Create a roadmap for learning Spanish in six months",
		"Write a mission statement for a climate nonprofit",
		"Design a themed dinner party menu",
		"Create a resume summary for a software engineer",
		"Write a thank-you note after a job interview",
		"Draft a script for a two-minute explainer video",
		"Create a content plan for a fitness coach",
		"Write a poem about rainy city streets",
		"Design a simple onboarding flow for a mobile app",
		"Create a list of icebreakers for a remote team meeting",
		"Write a grant proposal summary for a community garden",
		"Draft a polite cancellation email for a subscription",
		"Create a lesson plan about renewable energy",
		"Write a brand voice guide for a coffee shop",
		"Design a 7-day self-care plan",
		"Create a launch checklist for an online course",
		"Write a speech for a graduation ceremony",
		"Draft a one-page business plan for a pet grooming service",
		"Create a troubleshooting guide for home Wi-Fi issues",
		"Write a recipe for a quick weeknight pasta dinner",
		"Design a personal finance tracker layout",
		"Create a list of podcast episode ideas about startups",
		"Write a friendly reminder message for an upcoming event",
		"Draft a cover letter for a marketing role",
		"Create a travel itinerary for three days in Kyoto",
		"Write a short mystery story set in a museum",
	],
	Explore: [
		"What are trending AI research topics right now?",
		"Summarize the latest news about TypeScript",
		"Find interesting datasets for a side project",
		"Suggest tech blogs to follow for frontend performance",
		"Explain the main arguments for and against remote work",
		"Compare different approaches to personal knowledge management",
		"What should I know before learning machine learning?",
		"Explore the history of open-source software",
		"Explain how electric vehicles affect the power grid",
		"Compare popular note-taking systems for students",
		"What are the tradeoffs between SQL and NoSQL databases?",
		"Explain why some startups choose freemium pricing",
		"What are the biggest challenges in space exploration?",
		"Explore how recommendation algorithms shape media habits",
		"Compare different ways to learn a new language",
		"What are the benefits and risks of biometric authentication?",
		"Explain how carbon markets work",
		"Explore the future of wearable health technology",
		"Compare monoliths, microservices, and modular monoliths",
		"What makes a city friendly for cyclists?",
		"Explain the basics of behavioral economics",
		"Explore how music streaming changed the music industry",
		"Compare different productivity methods for creative work",
		"What are the ethical issues around facial recognition?",
		"Explain how vaccines are developed and tested",
		"Explore the history of the internet in five milestones",
		"Compare different renewable energy sources",
		"What should founders know about product-market fit?",
		"Explain how inflation affects household budgets",
		"Explore why some games become cultural phenomena",
		"Compare the strengths of Python, Go, and Rust",
		"What are the signs of a healthy engineering culture?",
		"Explain how supply chains recover from disruption",
		"Explore how cities can prepare for extreme heat",
		"Compare different approaches to digital privacy",
		"What makes a scientific study trustworthy?",
		"Explain how venture capital funding rounds work",
		"Explore the psychology of habit formation",
		"Compare traditional search engines and AI answer engines",
		"What are promising uses for augmented reality?",
		"Explain how public transit planning works",
		"Explore the impact of automation on office work",
		"Compare popular project management frameworks",
		"What are the basics of climate adaptation?",
		"Explain how encryption protects messages",
		"Explore why certain brands build strong communities",
		"Compare different ways to evaluate model quality",
		"What are common causes of software project delays?",
		"Explain how nutrition labels should be read",
		"Explore how online communities set and enforce norms",
	],
	Code: [
		"Refactor this React component for readability",
		"Write unit tests for a Node.js service",
		"Explain how to debounce an input in React",
		"Show an example of a Zod schema with refinement",
		"Debug this React component and suggest performance improvements",
		"Analyze the pros and cons of different programming languages",
		"Write a TypeScript utility to group objects by key",
		"Create a Hono route with Zod request validation",
		"Explain how React Server Components work",
		"Write a SQL query to find duplicate email addresses",
		"Design a REST API for a simple task manager",
		"Convert this JavaScript function to strict TypeScript",
		"Explain how to avoid prop drilling in React",
		"Write a Vitest test for an async function",
		"Create a reusable pagination helper",
		"Explain the difference between promises and async/await",
		"Write a custom React hook for local storage",
		"Design a database schema for event registrations",
		"Review this function for edge cases and bugs",
		"Explain how indexes improve database query speed",
		"Write a TypeScript type guard for API responses",
		"Create a small CLI script that renames files",
		"Explain how CORS works in a web application",
		"Write a migration-safe plan for renaming a database column",
		"Create a TanStack Query hook for loading projects",
		"Explain how to structure errors in an API",
		"Write a utility to validate environment variables",
		"Design a rate limiter for an HTTP endpoint",
		"Explain when to use useMemo in React",
		"Write a function to parse and format currency values",
		"Create a type-safe configuration object",
		"Explain how WebSockets differ from server-sent events",
		"Write a test plan for a login flow",
		"Create a small middleware for request logging",
		"Explain how optimistic updates work",
		"Write a function to sort semantic version strings",
		"Design an authorization model for teams and projects",
		"Explain how to diagnose a memory leak in Node.js",
		"Write a reusable form validation schema",
		"Create a simple caching layer with expiration",
		"Explain the difference between unit and integration tests",
		"Write a utility to retry failed network requests",
		"Design a file upload flow with progress reporting",
		"Explain how to prevent SQL injection",
		"Write a React component with accessible keyboard navigation",
		"Create a script to summarize JSON log files",
		"Explain how package lockfiles prevent dependency drift",
		"Write a type-safe event emitter in TypeScript",
		"Design a feature flag system for a frontend app",
		"Explain how to profile slow rendering in React",
	],
	"Image gen": [
		"Generate an image of a cyberpunk city at night",
		"Create a serene mountain landscape at sunrise",
		"Design a futuristic robot assistant",
		"Generate a cozy reading nook with warm afternoon light",
		"Create a watercolor illustration of a seaside village",
		"Design a sleek electric motorcycle concept",
		"Generate a fantasy library hidden inside a giant tree",
		"Create a minimalist poster for a jazz festival",
		"Design a friendly mascot for a meal planning app",
		"Generate a cinematic shot of astronauts on Mars",
		"Create a product photo of a premium ceramic coffee mug",
		"Design a retro travel poster for Lisbon",
		"Generate an isometric workspace for a game developer",
		"Create a children's book illustration of a moonlit garden",
		"Design a modern logo concept for a climate startup",
		"Generate a high-fashion editorial portrait in a studio",
		"Create a botanical pattern for sustainable packaging",
		"Design a concept art scene for an underwater city",
		"Generate a realistic kitchen with Scandinavian design",
		"Create a vibrant album cover for an indie pop band",
		"Design a sci-fi control room with holographic displays",
		"Generate a macro photo of dew on a red leaf",
		"Create a playful sticker pack for a productivity app",
		"Design a luxury hotel lobby with art deco details",
		"Generate a dramatic storm over a desert highway",
		"Create a pixel art village during a winter festival",
		"Design a packaging concept for herbal tea",
		"Generate a fantasy map of an island kingdom",
		"Create a realistic portrait of a chef in a busy kitchen",
		"Design a futuristic sneaker in a studio product shot",
		"Generate a peaceful Japanese courtyard after rain",
		"Create a movie poster for a space mystery thriller",
		"Design a colorful mural for a community center",
		"Generate a 3D render of a smart home device",
		"Create a fashion lookbook image with bold geometric styling",
		"Design a cozy cabin interior during a snowstorm",
		"Generate a surreal dreamscape with floating staircases",
		"Create a food photography shot of handmade ramen",
		"Design a character portrait for a cyberpunk detective",
		"Generate a realistic greenhouse full of tropical plants",
		"Create a clean app store hero image for a meditation app",
		"Design a stained glass window inspired by ocean waves",
		"Generate a vintage camera on a wooden desk",
		"Create a fantasy creature concept with iridescent wings",
		"Design a modern exhibition booth for an AI conference",
		"Generate a nighttime street market with neon signs",
		"Create a claymation-style scene of a tiny bakery",
		"Design a book cover for a historical adventure novel",
		"Generate a realistic sports car on a mountain road",
		"Create a dreamy cloud city at golden hour",
	],
} as const;

export type HeroSuggestionGroup = keyof typeof heroSuggestionGroups;
type HeroSuggestionGroupMap = Record<HeroSuggestionGroup, readonly string[]>;

const zhHeroSuggestionGroups = {
	Create: [
		"为假期储蓄制定一份预算计划",
		"为产品经理岗位设计一组面试问题",
		"用整整 100 个词写一篇短篇悬疑故事",
		"为本地面包店起草一份社交媒体内容日历",
		"像给 12 岁孩子讲一样解释量子计算",
		"为忙碌的职场人士设计 7 天健身计划",
		"为一款新效率工具撰写发布公告",
		"为素食家庭制定一周晚餐计划",
		"写一封礼貌申请项目延期的邮件",
		"设计一个提升专注力和精力的晨间流程",
		"整理一份搬进新公寓的检查清单",
		"为亲密朋友写一段真诚的生日祝福",
		"为降噪耳机撰写产品介绍",
		"设计一个 30 天习惯养成挑战",
		"为期末考试制定复习时间表",
		"为会议演讲嘉宾写一段专业简介",
		"为 SaaS 产品设计客户反馈问卷",
		"制定京都三日旅行行程",
		"为软件工程师写一段简历摘要",
		"为两分钟产品说明视频起草脚本",
	],
	Explore: [
		"现在有哪些热门 AI 研究方向？",
		"总结 TypeScript 最近的重要新闻",
		"为一个副项目寻找有趣的数据集",
		"推荐值得关注的前端性能技术博客",
		"解释远程办公的主要支持和反对观点",
		"比较不同个人知识管理方法",
		"学习机器学习前应该了解什么？",
		"梳理开源软件发展的关键历史",
		"解释电动汽车如何影响电网",
		"比较适合学生的常见笔记系统",
		"SQL 和 NoSQL 数据库有哪些取舍？",
		"解释为什么一些创业公司选择免费增值定价",
		"太空探索目前最大的挑战是什么？",
		"分析推荐算法如何塑造媒体消费习惯",
		"比较学习一门新语言的不同方法",
		"生物识别认证有哪些收益和风险？",
		"解释碳市场的运作方式",
		"探索可穿戴健康技术的未来",
		"比较单体、微服务和模块化单体架构",
		"什么样的城市对骑行者更友好？",
	],
	Code: [
		"重构这个 React 组件以提升可读性",
		"为一个 Node.js 服务编写单元测试",
		"解释如何在 React 中实现输入防抖",
		"展示一个带 refinement 的 Zod schema 示例",
		"调试这个 React 组件并给出性能优化建议",
		"分析不同编程语言的优缺点",
		"编写一个按 key 分组对象数组的 TypeScript 工具函数",
		"创建一个带 Zod 请求校验的 Hono 路由",
		"解释 React Server Components 的工作原理",
		"写一条 SQL 查询找出重复邮箱地址",
		"为简单任务管理器设计 REST API",
		"把这个 JavaScript 函数转换成严格 TypeScript",
		"解释如何避免 React 中的 prop drilling",
		"为异步函数编写一个 Vitest 测试",
		"创建一个可复用的分页辅助函数",
		"解释 Promise 和 async/await 的区别",
		"编写一个用于 localStorage 的自定义 React hook",
		"为活动报名设计数据库 schema",
		"审查这个函数的边界情况和潜在 bug",
		"解释索引如何提升数据库查询速度",
	],
	"Image gen": [
		"为太空悬疑惊悚片创作一张电影海报",
		"生成一个智能家居设备的 3D 渲染图",
		"生成一张岛屿王国的奇幻地图",
		"创作一幅海边村庄的水彩插画",
		"生成一张忙碌厨房中厨师的写实肖像",
		"生成一个斯堪的纳维亚风格的写实厨房",
		"生成夜晚赛博朋克城市图像",
		"创作一幅日出时的宁静山景",
		"设计一个未来感机器人助手",
		"生成一个午后暖光下的舒适阅读角",
		"设计一款流线型电动摩托概念图",
		"生成一座藏在巨树内部的奇幻图书馆",
		"创作一张极简爵士音乐节海报",
		"设计一个膳食计划应用的友好吉祥物",
		"生成宇航员在火星上的电影感镜头",
		"为高端陶瓷咖啡杯创作产品摄影图",
		"设计一张里斯本复古旅行海报",
		"生成一个游戏开发者的等距工作空间",
		"创作一幅月光花园儿童绘本插画",
		"为气候创业公司设计现代 logo 概念",
	],
} satisfies HeroSuggestionGroupMap;

export function getHeroSuggestionGroups(
	locale: Locale,
): HeroSuggestionGroupMap {
	return locale === "zh-CN" ? zhHeroSuggestionGroups : heroSuggestionGroups;
}

export const videoStudioSuggestions = [
	"A cinematic drone shot flying through a neon-lit futuristic city at night",
	"A serene timelapse of clouds moving over mountain peaks at sunset",
	"A slow-motion shot of ocean waves crashing on a rocky coastline",
	"A magical forest with glowing fireflies and swirling mist",
	"An astronaut floating in space with Earth visible in the background",
	"A bustling Tokyo street scene in the rain with neon reflections",
	"A timelapse of a city waking up from night to morning",
	"A cozy coffee shop interior with rain on the windows",
	"A surfer riding a massive wave at golden hour",
	"A field of wildflowers swaying in the wind under a dramatic sky",
	"A vintage steam train passing through snowy mountains",
	"An aerial view of a winding river through an autumn forest",
	"A bioluminescent beach at night with glowing waves",
	"A colorful marketplace in Marrakech with vibrant crowds",
	"Northern lights dancing over a frozen lake",
	"A chef preparing sushi in a high-end Japanese restaurant",
	"A flock of birds forming patterns against a sunset sky",
	"A lighthouse standing firm against crashing storm waves",
	"A supercell thunderstorm forming over open plains",
	"A timelapse of flowers blooming in a sunlit garden",
	"An underwater shark gliding through a coral reef",
	"A motorcycle ride through winding mountain roads",
	"A cozy cabin fireplace with snow falling softly outside",
	"A close-up of raindrops landing on a colorful autumn leaf",
	"A rocket launching at dawn with dramatic golden light",
	"A waterfall cascading into a lush tropical jungle pool",
	"A nighttime carnival with a ferris wheel glowing in motion",
	"Two people sharing an umbrella on a rainy Paris street",
	"A wolf running through a snow-covered pine forest",
	"A hot air balloon drifting over the Cappadocia valley at sunrise",
] as const;

const zhVideoStudioSuggestions = [
	"夜晚发光海浪拍打在生物荧光海滩上的镜头",
	"温暖木屋壁炉旁，窗外雪花轻柔飘落",
	"秋日森林中蜿蜒河流的航拍镜头",
	"海浪慢动作拍打岩石海岸线",
	"瀑布倾泻进入郁郁葱葱的热带丛林水潭",
	"高端日料餐厅里厨师制作寿司的镜头",
	"无人机穿越霓虹闪烁的未来城市夜景",
	"山峰上方云层流动的日落延时镜头",
	"萤火虫和薄雾环绕的魔法森林",
	"宇航员漂浮在太空中，背景是地球",
	"雨中东京街头霓虹倒影的繁忙场景",
	"城市从深夜到清晨苏醒的延时镜头",
] as const;

export function getVideoStudioSuggestions(locale: Locale): readonly string[] {
	return locale === "zh-CN" ? zhVideoStudioSuggestions : videoStudioSuggestions;
}

export const canvasSuggestions = [
	"A pricing page with three tiers and a highlighted popular plan",
	"A SaaS analytics dashboard with stat cards and a recent activity table",
	"A login form with email, password, and social sign-in buttons",
	"A landing page hero with a headline, subtitle, and two call-to-action buttons",
	"A user profile card with avatar, bio, and follow button",
	"A checkout summary with line items, totals, and a pay button",
	"A kanban board with three columns of task cards",
	"A settings page with grouped toggles and a save button",
	"A testimonial section with three customer quote cards",
	"An onboarding checklist with a progress bar and completed steps",
	"A newsletter signup section with an input and subscribe button",
	"A FAQ section with expandable questions",
	"A team page with a grid of member cards",
	"A product detail layout with gallery, description, and buy button",
	"A job board listing with filters and job cards",
	"An invoice template with a company header and itemized table",
	"A contact form with name, email, subject, and message fields",
	"A weather widget showing current conditions and a 5-day forecast",
	"A blog post layout with title, author byline, and article body",
	"A feature comparison table for two products",
] as const;

const zhCanvasSuggestions = [
	"一个包含图库、描述和购买按钮的商品详情布局",
	"一个带邮箱、密码和社交登录按钮的登录表单",
	"一个包含三列任务卡片的看板",
	"一个包含明细、总计和支付按钮的结账摘要",
	"一个带标题、作者署名和正文的博客文章布局",
	"一个展示当前天气和 5 天预报的天气组件",
	"一个包含三档套餐并突出热门方案的价格页",
	"一个带统计卡片和最近活动表的 SaaS 分析仪表盘",
	"一个带头像、简介和关注按钮的用户资料卡",
	"一个带分组开关和保存按钮的设置页面",
	"一个包含进度条和完成步骤的新手引导清单",
	"一个带输入框和订阅按钮的 newsletter 注册区块",
] as const;

export function getCanvasSuggestions(locale: Locale): readonly string[] {
	return locale === "zh-CN" ? zhCanvasSuggestions : canvasSuggestions;
}

export const audioStudioSuggestions = [
	"Welcome to doteb — one API for every model, with unified billing and analytics.",
	"Thanks for calling. All of our agents are currently busy, but your call is important to us.",
	"Chapter one. The storm rolled in just after midnight, and the old lighthouse keeper knew the night would be long.",
	"Breaking news: scientists have discovered a new species of deep-sea creature off the coast of Japan.",
	"Take a deep breath in... and slowly release. Let the tension melt away from your shoulders.",
	"In a world where artificial intelligence writes the headlines, one developer dares to read the documentation.",
	"Your order has shipped! Expect delivery within three to five business days.",
	"Good evening, passengers. We are now beginning our descent into Lisbon, where the local time is 7:45 PM.",
	"Once upon a time, in a village nestled between two mountains, there lived a clockmaker who could repair anything but time itself.",
	"Today's forecast calls for clear skies, a gentle breeze, and a high of 24 degrees.",
	"Attention shoppers: the store will be closing in fifteen minutes. Please bring your final purchases to the register.",
	"And the winner of this year's award for best original soundtrack goes to...",
	"Step right up, ladies and gentlemen, and witness the most astonishing spectacle of the century!",
	"This is your captain speaking. We've reached our cruising altitude of 35,000 feet.",
	"The quick brown fox jumps over the lazy dog, while the curious cat watches from the windowsill.",
	"Hello and welcome back to the podcast. Today we're diving into the history of the synthesizer.",
	"Please leave your message after the tone, and we'll get back to you as soon as possible.",
	"Five, four, three, two, one — liftoff! We have liftoff of the morning research mission.",
	"Remember: a journey of a thousand miles begins with a single step.",
	"It was the best of times, it was the worst of times, it was the age of wisdom, it was the age of foolishness.",
] as const;

const zhAudioStudioSuggestions = [
	"五、四、三、二、一，发射！清晨科研任务已经升空。",
	"请在提示音后留言，我们会尽快回复你。",
	"本年度最佳原创配乐奖的获奖者是……",
	"从前，在两座山之间的村庄里，住着一位钟表匠。他什么都能修，唯独修不好时间本身。",
	"欢迎使用 doteb，一个 API 连接所有模型，并提供统一计费和分析。",
	"突发新闻：科学家在日本近海发现了一种新的深海生物。",
	"感谢来电。我们的客服目前都在忙线中，但你的来电对我们很重要。",
	"第一章。暴风雨刚过午夜便袭来，老灯塔看守人知道这个夜晚会很漫长。",
	"深吸一口气……然后慢慢呼出，让肩膀上的紧张感逐渐消散。",
	"你的订单已经发货，预计三到五个工作日内送达。",
	"各位旅客晚上好，我们即将开始下降，目的地里斯本当地时间为晚上 7 点 45 分。",
	"欢迎回到本期播客，今天我们将聊聊合成器的发展历史。",
] as const;

export function getAudioStudioSuggestions(locale: Locale): readonly string[] {
	return locale === "zh-CN" ? zhAudioStudioSuggestions : audioStudioSuggestions;
}

export function sampleSuggestions(
	items: readonly string[],
	count: number,
): readonly string[] {
	const shuffled = [...items];

	for (let i = shuffled.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		const current = shuffled[i]!;
		shuffled[i] = shuffled[j]!;
		shuffled[j] = current;
	}

	return shuffled.slice(0, count);
}
